import type { ReactNode } from 'react';
import styled from 'styled-components';

import { HeadlineL } from '#src/atoms/typography/index.tsx';

const Root = styled(HeadlineL)`
  color: var(--c-onBase-primary);
  display: flex;
  flex-direction: row;
  align-items: center;
`;

type Props = {
  title: string | ReactNode;
};

export const BlockHeader = ({ title }: Props) => {
  return <Root as="h3">{title}</Root>;
};
